import { useCreate, useOne, useParse, useTranslation } from "@refinedev/core";
import { CreateEventStep, EventType } from "interfaces";
import { FullScreenLoading } from "components/fullScreenLoading";
import { HistoryLogButton } from "components/historyLogButton";
import { get } from "lodash";
import Button from "components/button";
import { _openUrlOnNewTab } from "utills/helpers";
import { StepsMenu } from "components/shared/event";
import {
  AdditionalSetup,
  BuildEventPageStep,
  ParticipantTemplatesStep,
  TicketAndPhase,
} from "components/shared/event/sport/steps";

export const EditWPSSportEvent: React.FC = () => {
  const parse = useParse();
  const { params } = parse();
  const { mutate: createMutation } = useCreate();
  const { translate, getLocale } = useTranslation();

  const { data, isLoading, refetch } = useOne<any>({
    resource: "events/sports",
    id: `${params?.id}${
      Number(params?.step) === CreateEventStep.BUILD_EVENT_PAGE
        ? ""
        : "?simple=true"
    }`,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!(params?.step && params?.id),
    } as any,
  });

  const eventDetailData = data?.data;

  const renderStep = (eventDetailData: any) => {
    const step = Number(params?.step ?? 1);
    if (step <= eventDetailData.current_step + 1) {
      switch (step) {
        case CreateEventStep.BUILD_EVENT_PAGE:
          return <BuildEventPageStep eventDetailData={eventDetailData} />;
        case CreateEventStep.PARTICIPANT_TEMPLATE:
          return (
            <ParticipantTemplatesStep
              eventDetailData={eventDetailData}
              refetchEventDetail={refetch}
            />
          );
        case CreateEventStep.CREATE_TICKET_PHASE:
          return (
            <TicketAndPhase
              eventDetailData={eventDetailData}
              refetchEventDetail={refetch}
            />
          );
        case CreateEventStep.ADDITIONAL_SETUP:
          return <AdditionalSetup eventDetailData={eventDetailData} />;
        // case CreateEventStep.PUBLISH:
        //   return <></>;
        default:
          return <></>;
      }
    }
    return <></>;
  };

  const _redirectPreviewPage = (eventId: string) => {
    createMutation(
      {
        resource: "events/preview",
        meta: {
          ignoreResourceWrapper: true,
        },
        values: {
          event_id: eventId,
        },
      },
      {
        onSuccess: (data) => {
          const previewUrl = get(data, "data.data.preview_url", "/");
          _openUrlOnNewTab(previewUrl);
        },
      }
    );
  };

  if (isLoading) {
    return <FullScreenLoading />;
  }

  return (
    <div className="flex flex-col gap-4 h-full">
      <div className="shrink-0 py-4">
        <StepsMenu
          currentStep={eventDetailData?.current_step ?? 1}
          eventType={EventType.SPORT}
        />
      </div>
      <div className="flex-1 p-4">
        {eventDetailData ? (
          <div>
            <div className="flex justify-between items-center gap-x-2 mb-4">
              <p className="font-medium">
                {get(eventDetailData, `name.${getLocale()}`, "") ??
                  eventDetailData?.name[
                    Object.keys(eventDetailData.name)[0] ?? "en"
                  ] ??
                  ""}{" "}
              </p>
              <div className="flex items-center gap-x-3">
                <Button
                  className="text-sm w-fit border-solid border-brand-500 border-[1px] py-2"
                  onClick={() =>
                    _redirectPreviewPage(eventDetailData?.id ?? "")
                  }
                >
                  {translate("preview")}
                </Button>
                {Number(params?.step) !==
                CreateEventStep.PARTICIPANT_TEMPLATE ? (
                  <HistoryLogButton
                    id="event-step"
                    resource={`/events/${eventDetailData?.id}/steps/${params?.step}/history`}
                    className="py-1.5"
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
            {renderStep(eventDetailData)}
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
